// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-device-width:640px) and (max-device-width:1025px) and (orientation:landscape){.faq-ls[data-v-6f9682af],.read-ls[data-v-6f9682af]{margin-left:0;margin-right:0}}", ""]);
// Exports
module.exports = exports;
